type AnimationDirection = 'left' | 'right' | 'up' | 'down';
export const animationClass = (inView: boolean, direction: AnimationDirection) => {
    if (inView){
        return ' transition-all duration-1000 animate__animated ' +
            direction === 'left' ? 'animate__fadeInLeft ' :
            direction === 'right' ? 'animate__fadeInRight ' :
            direction === 'up' ? 'animate__fadeInUp ' :
            'animate__fadeInDown ';
    } else {
        return ' transition-all duration-1000 opacity-0 ';
    }
}

export const animationStyle = (inView: boolean, direction: AnimationDirection, extraStyles = {}) => ({
  transform: inView ? 'translate(0, 0)' :  
          direction === 'left' ? 'translate(-50px, 0)' :
          direction === 'right' ? 'translate(50px, 0)' :
          direction === 'up' ? 'translate(0, 50px)' :
          'translate(0, -50px)',
  opacity: inView ? 1 : 0,
  transition: 'opacity 1s ease, transform 1s ease',
  ...extraStyles,
});